
import { IResponse, consumer } from "@bemap/utils"

const ENDPOINT = '/invoices';

export interface IInvoice {
  id: number;
  seller_team: number;
  buyer_team: number;
  unit_price: number;
  amount: number;
  quantity: number;
  currency: string;
  discount_fixed?: number;
  discount_percent?: number;
  discount_type?: 'fixed' | 'percent';
  status: 'paid' | 'open' | 'overdue' | 'cancelled';
  created_at: string;
  updated_at: string;
  stripeInvoiceId?: string;
  hosted_invoice_url?: string;
  seller?: {
    id: number;
    name: string;
  };
  buyer?: {
    id: number;
    name: string;
  };
}

export const getInvoices = async (startDate?: string, endDate?: string): Promise<IResponse> => {
  let url = ENDPOINT;

  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  }

  try {
    return await consumer('GET', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const getInvoiceById = async (id: number): Promise<IResponse> => {
  try {
    return await consumer('GET', `${ENDPOINT}/${id}`);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const createInvoice = async (invoiceData: Partial<IInvoice>): Promise<IResponse> => {
  try {
    return await consumer('POST', ENDPOINT, invoiceData);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const sendToStripe = async (id: number): Promise<IResponse> => {
  try {
    return await consumer('POST', `${ENDPOINT}/${id}/send-to-stripe`);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const payInvoice = async (id: number): Promise<IResponse> => {
  try {
    return await consumer('POST', `${ENDPOINT}/${id}/pay`);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const returnToUnpaid = async (id: number): Promise<IResponse> => {
  try {
    return await consumer('POST', `${ENDPOINT}/${id}/return-to-unpaid`);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const deleteInvoice = async (id: number): Promise<IResponse> => {
  try {
    return await consumer('DELETE', `${ENDPOINT}/${id}`);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const getInvoiceStatusStats = async (startDate?: string, endDate?: string): Promise<IResponse> => {
  let url = `${ENDPOINT}/statistics/status`;

  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  }

  try {
    return await consumer('GET', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const getInvoiceMetricsStats = async (startDate?: string, endDate?: string): Promise<IResponse> => {
  let url = `${ENDPOINT}/statistics/metrics`;

  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  }

  try {
    return await consumer('GET', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const getMonthlyInvoiceStats = async (startDate?: string, endDate?: string): Promise<IResponse> => {
  let url = `${ENDPOINT}/statistics/monthly`;

  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  }

  try {
    return await consumer('GET', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
}; 